export const boardFormCategoriesTour = {
  key: "boardFormCategories",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-formcat-categories"]',
      content: t("Tour_BoardFormCat_Categories"),
      placement: "top",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-formcat-departments"]',
      content: t("Tour_BoardFormCat_Departments"),
      placement: "top",
    },
    {
      target: '[data-tour="board-formcat-statuses"]',
      content: t("Tour_BoardFormCat_Statuses"),
      placement: "top",
    },
  ],
};
